import { FC } from "react";

export interface ComplimentaryIconProps {}

export const ComplimentaryIcon: FC<ComplimentaryIconProps> = ({}) => {
    return (
        <svg width="300" height="300" viewBox="0 0 300 300" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1376_9001)">
                <path
                    d="M150.476 0C150.308 0 150.14 0 149.972 0C122.812 0 97.3309 7.28019 75.3223 19.8805L150.42 149.972V0H150.476Z"
                    fill="#FEF121"
                />
                <path
                    d="M75.3789 19.8809C63.8426 26.545 53.2583 34.6093 43.9621 43.9615C34.7778 53.1457 26.8256 63.506 20.2734 74.8183L150.533 150.028L75.3789 19.8809Z"
                    fill="#8AD21B"
                />
                <path
                    d="M280.008 75.2109C273.4 63.7306 265.336 53.2023 256.039 43.9061C246.911 34.7778 236.551 26.8256 225.351 20.2734L150.477 150.029L280.008 75.2109Z"
                    fill="#F6AC43"
                />
                <path
                    d="M225.351 20.3285C203.342 7.5042 177.805 0.112003 150.477 0V150.028L225.351 20.3285Z"
                    fill="#FACE32"
                />
                <path
                    d="M300.001 150.028C300.001 122.811 292.72 97.2742 280.008 75.2656L150.477 150.028H300.001Z"
                    fill="#FB7833"
                />
                <path d="M20.2165 74.8184C7.3922 96.9389 0 122.588 0 150.028H150.476L20.2165 74.8184Z" fill="#34B534" />
                <path
                    d="M20.2168 225.237C26.769 236.55 34.7212 246.91 43.9054 256.094C53.2577 265.446 63.842 273.511 75.3223 280.119L150.42 150.027L20.2168 225.237Z"
                    fill="#197AC4"
                />
                <path d="M0 150.027C0 177.468 7.3922 203.117 20.2165 225.237L150.476 150.027H0Z" fill="#1BB3CF" />
                <path
                    d="M150.477 150.027L280.008 224.789C292.72 202.781 300.001 177.244 300.001 150.027H150.477Z"
                    fill="#FF4929"
                />
                <path
                    d="M225.351 279.727C236.607 273.175 246.911 265.278 256.039 256.094C265.336 246.798 273.4 236.27 280.008 224.789L150.477 150.027L225.351 279.727Z"
                    fill="#D24499"
                />
                <path
                    d="M75.3789 280.119C97.3875 292.775 122.812 299.999 150.029 299.999C150.197 299.999 150.365 299.999 150.533 299.999V150.027L75.3789 280.119Z"
                    fill="#525EBA"
                />
                <path
                    d="M150.477 299.999C177.749 299.887 203.342 292.495 225.351 279.671L150.477 150.027V299.999Z"
                    fill="#7E38B0"
                />
                <path
                    d="M255.115 42.4081L43.8379 255.787L47.8174 259.727L259.094 46.3484L255.115 42.4081Z"
                    className="fill-black dark:fill-white"
                />
                <path
                    d="M262.311 64.0097C251.502 66.8658 240.414 60.4256 237.558 49.6173C234.702 38.809 241.142 27.7207 251.95 24.8647C262.759 22.0086 273.847 28.4488 276.703 39.257C279.559 50.0653 273.119 61.1536 262.311 64.0097Z"
                    fill="#F6AC43"
                />
                <path
                    d="M257.158 67.4808C246.965 67.4808 237.613 60.6487 234.869 50.3444C231.621 38.08 238.957 25.4237 251.221 22.1756C263.486 18.9275 276.142 26.2637 279.39 38.5281C282.638 50.7924 275.302 63.4487 263.038 66.6968C261.078 67.2568 259.118 67.4808 257.158 67.4808ZM257.158 26.9918C255.702 26.9918 254.19 27.1598 252.677 27.5518C248.197 28.7278 244.389 31.6399 242.093 35.672C239.741 39.7041 239.125 44.4082 240.301 48.8883C242.765 58.1846 252.285 63.7287 261.638 61.2647C270.934 58.8006 276.478 49.2243 274.014 39.9281C271.942 32.1999 264.83 26.9918 257.158 26.9918Z"
                    className="fill-black dark:fill-white"
                />
                <path
                    d="M50.9611 277.32C40.1528 280.176 29.0645 273.736 26.2084 262.928C23.3523 252.12 29.7925 241.031 40.6008 238.175C51.4091 235.319 62.4974 241.759 65.3535 252.568C68.2095 263.376 61.7694 274.464 50.9611 277.32Z"
                    fill="#197AC4"
                />
                <path
                    d="M45.8083 280.791C35.6161 280.791 26.2638 273.959 23.5197 263.655C21.9517 257.719 22.7917 251.503 25.8718 246.182C28.9519 240.862 33.936 237.054 39.8722 235.486C52.1365 232.238 64.7928 239.574 68.0409 251.839C69.609 257.775 68.7689 263.991 65.6889 269.311C62.6088 274.631 57.6246 278.439 51.6885 280.007C49.7284 280.567 47.7124 280.791 45.8083 280.791ZM45.8083 240.358C44.3523 240.358 42.8403 240.526 41.3282 240.918C36.8481 242.094 33.04 245.006 30.7439 249.039C28.3919 253.071 27.7758 257.775 28.9519 262.255C30.1279 266.735 33.04 270.543 37.0161 272.839C41.0482 275.191 45.7523 275.807 50.2324 274.631C54.7126 273.455 58.5207 270.543 60.8167 266.567C63.1688 262.535 63.7848 257.831 62.6088 253.351C60.5927 245.51 53.4805 240.358 45.8083 240.358Z"
                    className="fill-black dark:fill-white"
                />
            </g>
            <defs>
                <clipPath id="clip0_1376_9001">
                    <rect width="300" height="300" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
